import { useMemo } from 'react';
import { connect } from 'react-redux';
import Link from '../../../../components/Link';
import constants from '../../../../constants';
import {
  WarningBanner,
  BannerContent,
  BannerIcon,
  BannerText
} from './styles';

interface ComponentProps {
  style?: React.CSSProperties;
  expertInformation;
}

const Component = ({
  expertInformation,
  style
}: ComponentProps) => {

  const isMoraLevelOne = useMemo(() => {
    console.log('expertInformation?.delinquency', expertInformation);
    return expertInformation?.delinquency === "Level_1";
  }, [expertInformation?.delinquency])

  if (!isMoraLevelOne) {
    return <></>;
  }

  const supportUrl = `${constants.whatsapp.url}?phone=${constants.whatsapp.number}&text=${encodeURIComponent('Hola, necesito ayuda con mi pago pendiente.')}`;

  return (
    <WarningBanner style={style}>
      <BannerContent>
        <BannerIcon>⚠️</BannerIcon>
        <BannerText>
          <strong>Recordá completar tu pago pendiente.</strong> Poné al día tu cuenta y seguí usando Klouser sin interrupciones. ¿Dudas?{' '}
          <Link
            href={supportUrl}
            target="_blank"
            options={{ skin: 'white', size: 'sm', type: 'link', native: false }}
            style={{ textDecoration: 'underline', fontWeight: 600 }}
          >
            Contactá a soporte
          </Link>
          .
        </BannerText>
      </BannerContent>
    </WarningBanner>
  )
}

const state = ({ userStore }) => {
  const { data: user } = userStore.information;

  return {
    expertInformation: user?.expert,
  };
};

export default connect(state)(Component);

